import { Component, OnInit, Input } from "@angular/core";
import { FormService } from "../services/form.service";
import { FormBuilder } from "@angular/forms";
import { debounceTime } from "rxjs/operators";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";

@Component({
	selector: "app-form-table",
	templateUrl: "./form-table.component.html",
	styleUrls: ["./form-table.component.scss"],
})
export class FormTableComponent implements OnInit {
	constructor(public formService: FormService, private fb: FormBuilder) {}

	ngOnInit() {
		this.formService.form = this.formService.createForm();

		//ローカルストレージから読み込み
		if (localStorage.getItem("storage") !== null) {
			this.formService.storageItems = JSON.parse(localStorage.storage);
			this.formService.form.patchValue(this.formService.storageItems);
			this.formService.storageItems.workDetails.map((item) => {
				this.formService.workDetails.push(
					this.formService.createWorkDetailsForm(
						item.title,
						item.manday
					)
				);
			});
		} else {
			this.formService.clearform();
		}

		this.formService.checkRemoveBtn();
		this.formService.watchFormData();
	}

	drop(event: CdkDragDrop<string[]>) {
		moveItemInArray(
			this.formService.workDetails.controls,
			event.previousIndex,
			event.currentIndex
		);
		moveItemInArray(
			this.formService.workDetails.value,
			event.previousIndex,
			event.currentIndex
		);
		this.formService.saveData(this.formService.form.value);
	}
}
